import React,{ useState, useEffect } from "react";
import { 
    Button,
    Modal,
} from 'antd';
import QualificationForm from "./QualificationForm";

function CheckAvailability() {
    const [modalOpen, setModalOpen] = useState( false );
    const [doAutoFocus, setDoAutoFocus] = useState( false );
    const [koodoRedirectLoading, setKoodoRedirectLoading] = useState( false );
    const [standalonePhonePurchaseAttempt, setStandalonePhonePurchaseAttempt] = useState( false );
    const [standaloneTVPurchaseAttempt, setStandaloneTVPurchaseAttempt] = useState( false );

    useEffect(() => {
        const qualificationUpdateState = ({ detail }) => {
            setModalOpen(true);
            setDoAutoFocus(true);

            if( detail == 'standalone_phone_purchase_attempt' ) {
                setStandalonePhonePurchaseAttempt( true );
            }

            if( detail == 'standalone_tv_purchase_attempt' ) {
                setStandaloneTVPurchaseAttempt( true );
            }
        }

        document.addEventListener(`qualificationModalUpdateState`, qualificationUpdateState);
    },[]);

    const handleModalCancel = () => {
        setModalOpen(false);
        setDoAutoFocus(false);
    }

    return (
        <div className="startca-react-channel-listing-container">
            <Modal
                open={ modalOpen }
                onCancel={ handleModalCancel }
                footer={ <></> }
                className="react-check-availability-modal"
            >
                <div className="home-internet-packages-availability-form-container qualification-modal">
                    <QualificationForm 
                        handleModalCancel={ handleModalCancel }
                        modalOpen={ modalOpen }
                        doAutoFocus={ doAutoFocus }
                        koodoRedirectLoading={ koodoRedirectLoading }
                        setKoodoRedirectLoading={ setKoodoRedirectLoading }
                        standalonePhonePurchaseAttempt={ standalonePhonePurchaseAttempt }
                        standaloneTVPurchaseAttempt={ standaloneTVPurchaseAttempt }
                    />
                </div>
            </Modal>
        </div>
    )
}

export default CheckAvailability